import React, { useEffect, useState } from "react";
import logo from "../image/logo.png";

const Navbar = () => {
  // State to track the active link
  const [activeLink, setActiveLink] = useState("#home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    // Function to update active link based on the current URL hash
    const handleScroll = () => {
      const currentHash = window.location.hash || "#home";
      setActiveLink(currentHash);
    };

    // Add event listener for hash change
    window.addEventListener("hashchange", handleScroll);

    // Set the active link when the component mounts
    handleScroll();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("hashchange", handleScroll);
    };
  }, []);

  const styles = `
.navbar {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right:5%;
  padding-left:2%;
  background-color: #f5f7fa;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.navbar-logo img {
  width: 10vh;
}

.navbar-links {
  list-style: none;
  display: flex;
  gap: 20px;
}

.nav-item {
  position: relative;
}

.nav-link {
  text-decoration: none;
  font-size: 2.5vh;
  font-weight: 500;
  color: #3e2465;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #6c63ff;
}

.nav-link.active {
  color: #6c63ff;
  font-weight: bold;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  width: 100%;
  height: 3px;
  background-color: #6c63ff;
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

/* Hide hamburger icon by default */
.navbar-hamburger {
  display: none;
  font-size: 3vh;
  cursor: pointer;
}

/* Medium and Small screens (show hamburger menu) */
@media (max-width: 768px) {
.navbar {
  position: sticky;
  width: 90vw;
}
  .navbar-links {
    width: 40vw;
    display: none;
  }

  .navbar-hamburger {
    display: block;
  }

  /* When the menu is active, display it */
  .navbar-links.active {
    display: block;
    position: absolute;
    top: 60px;
    right: 0;
    width: 50vw;
    background-color: #f5f7fa;
    padding: 10px 0;
  }

  .navbar-links li {
    text-align: center;
    padding: 10px 0;
  }

  .navbar-links li a {
    font-size: 2vh;
    padding: 10px 20px;
    display: block;
    text-decoration: none;
    font-weight: 500;
    color: #3e2465;
  }
  .navbar-logo img {
    width: 8vh;
  }

  .nav-link.active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 100vw;
    height: 2px;
    background-color: #6c63ff;
    transition: width 0.3s ease;
    display: none;
  }
}
`;

  return (
    <>
      <style>{styles}</style>
      <nav className="navbar">
        <div className="navbar-logo">
          <img src={logo} alt="Appco Logo" />
        </div>
        {/* Hamburger Icon for smaller screens */}
        <div className="navbar-hamburger" onClick={toggleMenu}>
          ☰
        </div>
        <ul className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
          <li className="nav-item">
            <a
              href="#home"
              className={`nav-link ${activeLink === "#home" ? "active" : ""}`}
            >
              Home
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#feature"
              className={`nav-link ${
                activeLink === "#feature" ? "active" : ""
              }`}
            >
              Feature
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#WhyPhysiomize"
              className={`nav-link ${
                activeLink === "#WhyPhysiomize" ? "active" : ""
              }`}
            >
              Why Physio-mize
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#AppScreenshots"
              className={`nav-link ${
                activeLink === "#AppScreenshots" ? "active" : ""
              }`}
            >
              Software Overview
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#contactUs"
              className={`nav-link ${
                activeLink === "#contactUs" ? "active" : ""
              }`}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
